/**
 * WebView 브리지 메시지 타입 상수
 * 정의된 type만 사용 (Web ↔ Native postMessage)
 */
/** Web → Native 메시지 type (허용 목록) */
export const WEB_MESSAGE_TYPES = {
    NAVIGATE_BACK: 'NAVIGATE_BACK',
    FILE_DOWNLOAD: 'FILE_DOWNLOAD',
    /** 리프레시 토큰 저장/삭제 처리 결과 (Webview -> Native) */
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    /** 파일 업로드 요청 (모바일 WebView → Native 파일 선택기) */
    FILE_UPLOAD: 'FILE_UPLOAD',
    /** Web 앱 초기화 완료 시 전송 (딥링크/알림 URL 전달 타이밍 보장) */
    READY: 'READY',
    /** 테마 변경 시 전송 (상태바/네비게이션바 색상 동기화) */
    SET_THEME: 'SET_THEME',
    /** 파싱 실패·미지정 type fallback */
    RAW: 'RAW',
};
/** Native → Web 메시지 type (NATIVE_ 접두사 통일) */
export const NATIVE_MESSAGE_TYPES = {
    /** 앱 초기화 (푸시 토큰 등) */
    INIT: 'NATIVE_INIT',
    /** 하드웨어 백 버튼(Android) / 스와이프 백(iOS) 시 전송 */
    NAVIGATE_BACK: 'NATIVE_NAVIGATE_BACK',
    NAVIGATE: 'NATIVE_NAVIGATE',
    /** Native 파일 선택 결과 (모바일 WebView) */
    FILE_UPLOAD: 'NATIVE_FILE_UPLOAD',
    /** 리프레시 토큰 저장/삭제 처리 결과 (Native → Web) */
    REFRESH_TOKEN: 'NATIVE_REFRESH_TOKEN',
    /** 앱이 포그라운드로 복귀했을 때 전송 (WebSocket 재연결 등) */
    APP_FOREGROUND: 'NATIVE_APP_FOREGROUND',
    /** 앱이 백그라운드로 진입했을 때 전송 (stale 요청 토스트 억제 등) */
    APP_BACKGROUND: 'NATIVE_APP_BACKGROUND',
};
//# sourceMappingURL=constants.js.map